import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import { getStoreUtils } from '@fm-tools/core/composables';
import { useStore } from 'vuex';
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  setup(__props) {
    const {
      characters,
      activeCharacter,
      setCharacter,
      isActive
    } = getStoreUtils();
    const store = useStore();

    const getIcon = character => {
      if (character.partners.length > 1) return 'mdi-account-group';else if (character.partners.length > 0) return 'mdi-account-multiple';else return 'mdi-account';
    };

    const icon = computed(() => {
      if (activeCharacter.value) {
        return getIcon(activeCharacter.value);
      } else {
        if (characters.value.length > 2) return 'mdi-account-group-outline';else if (characters.value.length > 1) return 'mdi-account-multiple-outline';else return 'mdi-account-outline';
      }
    });

    const name = character => computed(() => character?.name.first + (character?.name.last ? ' ' + character.name.last : ''));

    return (_ctx, _cache) => {
                                                            

                                                          

                                                                                  

      const _component_v_list_item_action = _resolveComponent("v-list-item-action");

                                                                      

                                                            

                                                            

      return _openBlock(), _createBlock(_component_v_menu, {
        "offset-y": "",
        left: "",
        "open-on-hover": "",
        transition: "slide-y-transition"
      }, {
        activator: _withCtx(({
          on,
          attrs
        }) => [_unref(store).getters.isAuthenticated && _unref(characters) && _unref(characters).length > 0 ? (_openBlock(), _createBlock(_component_v_btn, _mergeProps({
          key: 0
        }, attrs, {
          text: "",
          title: _unref(activeCharacter) ? 'Select Character' : ''
        }, _toHandlers(on)), {
          default: _withCtx(() => [_createVNode(_component_v_icon, {
            left: "",
            icon: _unref(icon)
          }, null, 8, ["icon"]), _createTextVNode(" " + _toDisplayString(_unref(activeCharacter) ? name(_unref(activeCharacter)) : 'Select Character'), 1)]),
          _: 2
        }, 1040, ["title"])) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_unref(store).getters.isAuthenticated && _unref(characters) && _unref(characters).length > 0 ? (_openBlock(), _createBlock(_component_v_list, {
          key: 0
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(characters), (character, index) => {
            return _openBlock(), _createBlock(_component_v_list_item, {
              key: index,
              link: "",
              title: _unref(isActive)(character) ? 'Unselect this character' : 'Select this character',
              onClick: $event => _unref(setCharacter)(_unref(isActive)(character) ? null : character)
            }, {
              default: _withCtx(() => [_createVNode(_component_v_list_item_title, null, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(name(character)), 1)]),
                _: 2
              }, 1024), _createVNode(_component_v_list_item_action, null, {
                default: _withCtx(() => [_createVNode(_component_v_icon, {
                  icon: getIcon(character)
                }, null, 8, ["icon"])]),
                _: 2
              }, 1024)]),
              _: 2
            }, 1032, ["title", "onClick"]);
          }), 128))]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      });
    };
  }

});

/* Vuetify */
import { VBtn as _component_v_btn } from "vuetify/lib/components/VBtn/index.mjs"
import { VIcon as _component_v_icon } from "vuetify/lib/components/VIcon/index.mjs"
import { VListItemTitle as _component_v_list_item_title, VListItem as _component_v_list_item, VList as _component_v_list } from "vuetify/lib/components/VList/index.mjs"
import { VMenu as _component_v_menu } from "vuetify/lib/components/VMenu/index.mjs"

